// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import Playground__DemoComponentController from "./playground/demo_component_controller"
application.register("playground--demo-component", Playground__DemoComponentController)

import Playground__SandboxController from "./playground/sandbox_controller"
application.register("playground--sandbox", Playground__SandboxController)

import Playground__SidebarController from "./playground/sidebar_controller"
application.register("playground--sidebar", Playground__SidebarController)
